<template v-if="loaded">
    <div>
        <!-- Posts -->
        <div v-if="headers.total < 1 || !headers.total && !isFetching" class="text--large text--centered"><p>Er zijn geen resulaten gevonden.</p></div>
        <div v-else :class="getClasses">
            <div v-if="type === 'news'" class="overview__background"></div>
            <template v-for="post in filteredPosts">
                <story-teaser v-if="type === 'story'"
                    :title="post.title.rendered"
                    :link="post.link"
                    :person-name="post.acf.name"
                    :image-sizes="getImageSizes(post, 'teaser-story')"
                    :person-function="post.acf.job_function">
                </story-teaser>
                <news-teaser v-if="type === 'news'"
                    :title="post.title.rendered"
                    :link="post.link"
                    :image-sizes="getImageSizes(post, 'teaser-news')"
                    :post-date="new Date(post.date)">
                </news-teaser>
                <team-teaser v-if="type === 'team'"
                    :title="post.title.rendered"
                    :image-sizes="getImageSizes(post, 'teaser-team')"
                    :job-function="post.acf.job_function"
                    :email="post.acf.email"
                    :phone-number="post.acf.phone_number"
                    :whatsapp="post.acf.whatsapp"
                    :linkedin="post.acf.linkedin_profile">
                </team-teaser>
            </template>
        </div>
        <!-- LOADING -->
        <div class="overview__actions">
            <div v-if="isFetching && query.page > 1">
                <svg xmlns=" w3.org xmlns:xlink=" w3.org style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;" width="60px" height="60px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#009B96" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                </svg>
            </div>
            <button v-else-if="fetchCompleted && headers.total > 0" class="btn btn--b" @click="nextPosts" :hidden="query['page'] === headers['pages']">Meer laden</button>
        </div>
    </div>
</template>

<script>
import Icon from './Icon.vue';
import StoryTeaser from './StoryTeaser.vue';
import NewsTeaser from './NewsTeaser.vue';
import TeamTeaser from './TeamTeaser.vue';
import { store } from './store.js';

export default {
    name: 'Overview',
    components: {
      Icon,
      NewsTeaser,
      StoryTeaser,
      TeamTeaser
    },
    data() {
        return {
            loaded: false,
            posts: [],
            query: {
                page: 1,
                per_page: 6,
                orderby: 'date',
                order: 'desc',
                _embed: 1
            },
            headers: {},
            isFetching: false,
            fetchCompleted: false,
            store,
            overviewClass: 'overview--'+ this.type
        };
    },
    props: ['type'],
    computed: {
        filteredPosts() {
            return this.posts;
        },
        getClasses() {
            return [
                'overview',
                this.overviewClass
            ].join(' ');
        }
    },
    methods: {
        async fetchData() {
            this.loaded = true;
            this.isFetching = true;

            // Build the url query
            let url = [
                window.SITE_URL,
                this.store.endpoints[this.type],
                '?',
                this.getUrlParams(this.query)
            ].join('');

            try {
                const response = await fetch(url);

                if (response.ok) {
                    const data = await response.json();

                    // Map headers from response. Headers are used to determine if there are additional pages surrounding a query.
                    let headers = {
                        total: 'X-WP-Total',
                        pages: 'X-WP-TotalPages',
                        link: 'Link'
                    };

                    Object.keys(headers).forEach((key) => {
                        const header = response.headers.get(headers[key]);
                        const value = isNaN(header) ? header : parseInt(header) || 0;
                        headers[key] = value;
                    });

                    this.headers = headers;
                    
                    this.$nextTick(() => {
                        this.posts = [...this.posts,...data];
                        this.fetchCompleted = true;
                        this.isFetching = false;
                    });
                }
            } catch (error) {
                this.handleError(error);
            }
        },
        getUrlParams(query) {
            return new URLSearchParams(query).toString();

        },
        handleError(response) {
            // eslint-disable-next-line no-undef
            if (process.env.NODE_ENV === 'development') {
                console.dir(response);
            }

            this.isFetching = false;
        },
        nextPosts(event) {
            event.preventDefault();

            this.query['page']++;
            this.fetchData();
        },
        hasThumbnail(post) {
            return (post._embedded?.['wp:featuredmedia']?.[0]?.source_url);
        },
        // Return array with urls of the default and retina image based on the given image_size. 
        // Fallback to the original source_url
        getImageSizes(post, image_size) {
            if(!this.hasThumbnail(post)) {
                return false;
            }

            let sizes = [];

            if(this.urlForImageSize(post, image_size)) {
                sizes.push(this.urlForImageSize(post, image_size));
            }

            // check for image-size with -2x. This image size is usually registered in theme functions.php
            if(this.urlForImageSize(post, `${image_size}-2x`)) {
                sizes.push(this.urlForImageSize(post, `${image_size}-2x`));
            }

            // no image-size found, return the source url
            if(sizes.length === 0) {
                sizes.push(post._embedded['wp:featuredmedia'][0].source_url);
            }

            return sizes;
        },
        urlForImageSize(post, image_size) {
            if( post._embedded['wp:featuredmedia'][0].media_details.sizes[image_size]?.source_url) {
                return post._embedded['wp:featuredmedia'][0].media_details.sizes[image_size]?.source_url;
            }
        }
    },
    mounted: function() {
        if(this.type ==='team') {
            this.query.per_page = 100;
            this.query.orderby = 'title';
            this.query.order = 'asc';
        }

        this.fetchData();
    },
};
</script>

<style lang="scss">
</style>